
export const formMain = [
  {
    name: 'form',
    path: '/form',
    meta: {
      title: '自定义表单',
      icon: 'shezhi',
      plugin: 'form'
    }
  },
  {
    name: 'formList',
    path: '/form/list',
    component: () => import('/@/views/plugins/form/List.vue'),
    meta: { title: '表单列表', plugin: 'form' }
  },
  {
    name: 'formRecords',
    path: '/form/records',
    component: () => import('/@/views/plugins/form/Records.vue'),
    meta: { title: '提交记录', plugin: 'form' }
  }
]
export const formOpen = [
  {
    name: 'formHandle',
    path: '/form/handle',
    component: () => import('/@/views/plugins/form/Handle.vue'),
    meta: { title: '表单装修', plugin: 'form' }
  }
]
